// UI sound effects have been deliberately removed from N8ONE.
//
// Per the member directive, the only audio anywhere in the app is
// guided meditations, affirmations, and visualizations — all of which
// use dedicated voice components (`@/lib/readAloud`, ElevenLabs proxy)
// and dedicated meditation ambience/tone pads (`@/lib/breathAmbience`,
// `@/lib/healingTone432`). Everything else — reminder chimes, step
// bells, closing tones, breath pacer pings — is silent.
//
// The exports below remain as inert stubs so historical imports across
// the codebase do not break. The toggle helpers keep their storage
// shape so legacy settings do not read as `undefined`, but they no
// longer gate any audio because no audio is generated here.

const SOUND_KEY = "aging.reminders.sound";
const BREATH_SOUND_KEY = "breath.chime.enabled";

export function isSoundEnabled() {
  try {
    const v = localStorage.getItem(SOUND_KEY);
    return v === null ? false : v === "1";
  } catch { return false; }
}
export function setSoundEnabled(on) {
  try { localStorage.setItem(SOUND_KEY, on ? "1" : "0"); } catch { /* noop */ }
}
export function isBreathChimeEnabled() {
  try {
    const v = localStorage.getItem(BREATH_SOUND_KEY);
    return v === null ? false : v === "1";
  } catch { return false; }
}
export function setBreathChimeEnabled(on) {
  try { localStorage.setItem(BREATH_SOUND_KEY, on ? "1" : "0"); } catch { /* noop */ }
}

// Silent stubs — kept only so any lingering import site does not crash.
export function playChime() { /* removed */ }
export function playStepChime() { /* removed */ }
export function playCloseChime() { /* removed */ }
export function playInhaleTone() { /* removed */ }
export function playExhaleTone() { /* removed */ }
